// LLM generated - Model Claude 4 Sonnet
export default {
  // Default titles and labels
  title: 'Contest Huddle',

  // Tab labels
  tabs: {
    messages: 'Chat',
    posts: 'Posts',
  },

  // Placeholder text
  placeholders: {
    post: 'Post...',
    chat: 'Write a message...',
    postTitle: 'Post title',
    postContent: 'Type your text here...',
  },

  // Accessibility labels
  ariaLabels: {
    messageOptions: 'Message options',
    addReaction: 'Add reaction',
    addMedia: 'Add media',
    sendPost: 'Send post',
    commissionerMessages: 'Commissioner messages',
    notifications: '{{count}} notifications',
    expandChat: 'Expand chat',
    minimizeChat: 'Minimize chat',
    closeModal: 'Close modal',
    postOptions: 'Post options',
    reactToPost: 'React to post',
    userAvatar: "{{handle}}'s avatar",
    toggleChat: 'Toggle chat',
  },

  // Message composer
  messageComposer: {
    mobileAppMessage: 'Send messages in the mobile app',
  },

  // Empty states
  emptyStates: {
    posts: {
      title: 'No commissioner posts',
      descriptionCommish: 'Send a post. All entrants will be notified.',
      description:
        'Only {{commissionerHandle}} can send posts. All entrants will be notified if the commissioner sends a post.',
    },
    chatDisabled: {
      title: 'Chat disabled',
      description: 'The commissioner disabled chat for this contest.',
    },
    chatUnavailableOnWeb: {
      title: 'Not available on web app',
      description: 'Messages can only be accessed from the Splash Sports mobile app.',
    },
    noChats: {
      title: 'No messages',
      description: 'Nothing here yet, start the conversation.',
    },
    noChatsCommissioner: {
      title: 'Start the conversation',
      description: 'All contest entrants can react and respond to messages sent in the chat.',
    },
  },

  // Loading states
  loading: {
    olderPosts: 'Loading older posts...',
  },

  // Notifications
  notifications: {
    chatMuted: 'Chat is muted. You will not receive in-app or email notifications.',
    messageSent: 'Message sent',
    postSentSuccess: 'Post sent successfully.',
    postSentSuccessNotify: 'Post sent successfully. All entrants will be notified.',
    postUpdatedSuccess: 'Post updated successfully.',
    postDeletedSuccess: 'Post deleted successfully.',
    messageDeletedSuccess: 'Message deleted successfully.',
    postPinnedSuccess: 'Post pinned successfully.',
    postUnpinnedSuccess: 'Post unpinned successfully.',
    error: 'Error',
    messageSendFailed: 'Failed to send message. Please try again.',
    postUpdateFailed: 'Failed to update post. Please try again.',
    maxCharacterLimitExceeded: 'Exceeded maximum message length',
    postDeleteFailed: 'Failed to delete post. Please try again.',
    messageDeleteFailed: 'Failed to delete message. Please try again.',
    postPinFailed: 'Failed to pin post. Please try again.',
    postUnpinFailed: 'Failed to unpin post. Please try again.',
    postsMuted: 'Posts muted',
    postsUnmuted: 'Posts unmuted',
    postsMuteFailed: 'Failed to update mute settings. Please try again.',
    userMuted: 'Posts from @{{handle}} muted successfully',
    userUnmuted: 'You will now receive notifications when @{{handle}} posts',
    reportSubmitted: 'Report submitted',
    reportSubmittedMessage: 'Thank you for your report. We will review it shortly.',
    // Chat state notifications
    chatDisabled: 'Chat disabled',
    chatDisabledByCommissioner: 'Chat has been disabled by the commissioner.',
    chatEnabled: 'Chat enabled',
    chatEnabledByCommissioner: 'Chat has been enabled by the commissioner.',
    // User ban notifications
    userBanned: 'Access restricted',
    youHaveBeenBanned: 'You have been restricted from this chat.',
  },

  post: {
    createPostCTA: 'Create a new post',
    showMore: 'Show more',
    showLess: 'Show less',
    pin: 'Pin to the top',
    unpin: 'Unpin',
    pinned: 'Pinned',
    edit: 'Edit',
    delete: 'Delete',
    mute: 'Mute @{{handle}}',
    unmute: 'Unmute @{{handle}}',
    report: 'Report post',
  },
  message: {
    report: 'Report message',
    delete: 'Delete message',
  },

  // Post modal
  postModal: {
    title: 'New post',
    editTitle: 'Edit post',
    notifyEntrants: 'Notify all entrants',
    post: 'Post',
    update: 'Update',
    confirmClose: 'You have unsaved changes. Are you sure you want to close?',
  },

  // Delete post confirmation
  deletePost: {
    title: 'Do you want to delete this post?',
    description: "If you delete now, you'll lose this post.",
    confirm: 'Delete post',
    cancel: 'Cancel',
  },

  // Delete message confirmation
  deleteMessage: {
    title: 'Do you want to delete this message?',
    description: "If you delete now, you'll lose this message.",
    confirm: 'Delete message',
    cancel: 'Cancel',
  },

  // Pin post confirmation
  pinPost: {
    title: 'Pin this post',
    description:
      'Pinning this will replace your current pinned post and show it at the top of the page. Are you sure?',
    confirm: 'Pin',
    cancel: 'Cancel',
  },

  // Mute post confirmation
  mutePost: {
    title: 'Mute @{{handle}}?',
    description:
      "You won't get notified when @{{handle}} creates a post. You can always unmute them if you change your mind.",
    confirm: 'Mute',
    cancel: 'Cancel',
  },

  // Report modal
  reportModal: {
    title: {
      post: 'Report a post',
      message: 'Report a message',
    },
    reasons: {
      spam: "It's spam",
      inappropriate_content: 'It contains nudity or sexual activity',
      hate_speech: 'It contains hateful symbols and/or speech',
      harassment: 'It contains bullying or harassment practices',
      other: 'Something else',
    },
    buttons: {
      report: 'Report',
      cancel: 'Cancel',
    },
    ariaLabels: {
      close: 'Close report modal',
      selectReason: 'Select report reason',
    },
    placeholder: 'Tell us what you want to report...',
  },

  // Disable chat modal
  disableChatModal: {
    title: {
      disable: 'Disable chat?',
      enable: 'Enable chat?',
    },
    description: {
      disable:
        'Are you sure you want to disable chat for this contest? You can enable chat any time by tapping the chat icon.',
      enable:
        'Are you sure you want to enable chat for this contest? You can disable chat any time by tapping the chat icon.',
    },
    confirmButtonText: {
      disable: 'Disable chat',
      enable: 'Enable chat',
    },
    confirmButtonTextEnable: 'Enable chat',
    loadingTextDisable: 'Disabling...',
    loadingTextEnable: 'Enabling...',
    cancelButtonText: 'Cancel',
  },

  // Chat widget
  widget: {
    newPost__hasPlural: {
      one: '{{count}} new post',
      other: '{{count}} new posts',
    },
    unreadMessage__hasPlural: {
      one: '{{count}} unread message',
      other: '{{count}} unread messages',
    },
  },
};
